export default class ServiceFactory {
    constructor(_http) {
        this.$http = _http;
    }

    _loadPromise(promiFn) {
        return new Promise((resolve, reject) => {
            let promi = promiFn();
            promi.then(modu => {
                let instancia = new modu.default({http:this.$http});
                instancia.http = this.$http;
                resolve(instancia);
            });
        });
    }

    /* MIGRAÇÃO aqui abaixo estão os serviços já no novo padrão para melhorar o merge do app cordova e separar melhor as camadas para teste*/
    env() {return this._loadPromise(()=>System.import('./biz/EnvService'));}
    condicaoPagto() {return this._loadPromise(()=>System.import('./biz/CondicaoPagtoService'));}
    carrinho() {return this._loadPromise(()=>System.import('./biz/CarrinhoService'));}
    userPreference() {return this._loadPromise(()=>System.import('./biz/UserPreferenceService'));}
    publicacao() {return this._loadPromise(()=>System.import('./biz/PublicacaoService'));}
    pedido() {return this._loadPromise(()=>System.import('./biz/PedidoService'));}
    item() {return this._loadPromise(()=>System.import('./biz/ItemService'));}
    frete() {return this._loadPromise(() => System.import('./biz/FreteService'));}
    unidadeNegocio() {return this._loadPromise(() => System.import('./biz/UnidadeNegocioService'));}
    categoriaItem() {return this._loadPromise(() => System.import('./biz/CategoriaItemService'));}
    departamento() {return this._loadPromise(() => System.import('./biz/DepartamentoService'));}
    tabelaPreco() {return this._loadPromise(() => System.import('./biz/TabelaPrecoService'));}
    
    carousel() {return this._loadPromise(()=>System.import('./biz/CarouselService'));}
    banner() {return this._loadPromise(()=>System.import('./biz/BannerService'));}
    creditCard() { return this._loadPromise(() => System.import('./biz/CreditCardService')); }
    vindi() {return this._loadPromise(() => System.import('./biz/VindiService'));}
    cobrancaEletronica() {return this._loadPromise(() => System.import('./biz/CobrancaEletronicaService'));}
    itemCadastro() {return this._loadPromise(() => System.import('./biz/ItemCadastroService'));}
    contaBancaria() {return this._loadPromise(() => System.import('./biz/ContaBancariaService'));}
    lancamentos() {return this._loadPromise(() => System.import('./biz/LancamentosService'));}
    promocoes() {return this._loadPromise(() => System.import('./biz/PromocaoService'));}
    planilhaItens() {return this._loadPromise(() => System.import('./biz/PlanilhaItensService'));}
    separacao() {return this._loadPromise(() => System.import('./biz/SeparacaoService'));}
    integracaoMarketplace() {return this._loadPromise(() => System.import('./biz/IntegracaoMarketplaceService'));}
    devolucao() {return this._loadPromise(() => System.import('./biz/DevolucaoService'));}
    gofindService() {return this._loadPromise(() => System.import('./biz/GofindService'));}

    /* MIGRAÇÃO aqui acima estão os serviços já no novo padrão para melhorar o merge do app cordova e separar melhor as camadas para teste*/

    
    menu() {return this._loadPromise(() => System.import('./biz/MenuServiceBiz'));}
    role() {return this._loadPromise(() => System.import('./biz/RoleServiceBiz'));}
    usuario() {return this._loadPromise(() => System.import('./ws/UsuarioServiceWs'));}
    login() {return this._loadPromise(() => System.import('./ws/LoginServiceWs'));}
    empresa() {return this._loadPromise(() => System.import('./ws/EmpresaServiceWs'));}
    cliente() {return this._loadPromise(() => System.import('./ws/ClienteServiceWs'));}
    dicionario() {return this._loadPromise(() => System.import('./ws/DicionarioServiceWs'));}
    atributo() {return this._loadPromise(() => System.import('./ws/AtributoServiceWs'));}
    contato() {return this._loadPromise(() => System.import('./ws/ContatoServiceWs'));}
    notaFiscal() {return this._loadPromise(() => System.import('./ws/NotaFiscalServiceWs'));}
    duplicata() {return this._loadPromise(() => System.import('./ws/DuplicataServiceWs'));}
    calendario() {return this._loadPromise(() => System.import('./ws/CalendarioServiceWs'));}
    transportadora() {return this._loadPromise(() => System.import('./ws/TransportadoraServiceWs'));}
    novaSenha() {return this._loadPromise(() => System.import('./ws/NovaSenhaWs'));}
    resumoFinanceiro() {return this._loadPromise(() => System.import('./ws/ResumoFinanceiroServiceWs'));}
    
    itemFalta() {return this._loadPromise(() => System.import('./ws/ItemFaltaServiceWs'));}
    cupom() {return this._loadPromise(() => System.import('./ws/CupomServiceWs'));}
    
    lead() {return this._loadPromise(() => System.import('./ws/LeadServiceWs'));}
    meta() {return this._loadPromise(() => System.import('./ws/MetaServiceWs'));}
    metaSimples() {return this._loadPromise(() => System.import('./ws/MetaSimplesServiceWs'));}
    municipioPopulacao() {return this._loadPromise(() => System.import('./ws/MunicipioPopulacaoServiceWs'));}
    ead() {return this._loadPromise(() => System.import('./ws/EadServiceWs'));}
    perfilCursoEad() {return this._loadPromise(() => System.import('./ws/PerfilCursoEadServiceWs'));}
}


// WEBPACK FOOTER //
// ./src/components/services/ServiceFactory.js